import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  apiUrl: string;
  roles: any[] = [];
  appRoles: any[] = [];
  labs: any[] = [];
  lga_codes: any[] = [];
  collectionCenters: any[] = [];
  travelTypes: any[] = [];
  countries: any[] = [];

  constructor(
    private http: HttpClient,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  getRoles() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "roles";
    this.http.get<any>(this.apiUrl).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.roles = data.response;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }
  getAppRoles() {
    this.spinnerService.show();
    const appId = localStorage.getItem("application_id");
    console.log(appId);
    this.apiUrl = environment.AUTHAPIURL + `applications/${appId}/roles`;
    this.http.get<any>(this.apiUrl).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.appRoles = data.response;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  getLabs() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "labs-list";
    this.http.post<any>(this.apiUrl, {}).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.labs = data.response.data;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  getLgaCodes() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "lga-list";
    this.http.post<any>(this.apiUrl, {}).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.lga_codes = data.response;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  getCollectionCenters() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "collection-center-list";
    this.http.post<any>(this.apiUrl, {}).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.collectionCenters = data.response.data;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  getCollectionCentersList() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "collection-center/list";

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, "", { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();
        if (data.status == true) {
          this.collectionCenters = data.response.data;
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  getTravelTypes() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "travel-types";
    this.http.get<any>(this.apiUrl).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.travelTypes = data.response;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }


  getCountries() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "countries";
    this.http.get<any>(this.apiUrl).subscribe((data) => {
      this.spinnerService.hide();
      console.log(data);
      if (data.status == true) {
        this.countries = data.response;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  getErrorMessage(data: any, type = 1): string {
    let errorMessage = data.message;
    if (data.response && data.response.length) {
      errorMessage = "";
      const errors = data.response;
      for (let i = 0; i < errors.length; i++) {
        errorMessage += errors[i]["message"] + " <br />";
      }
    }
    return errorMessage;
  }
}
